/* eslint-disable max-len */
import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { useNavigate } from 'react-router-dom';

const UploadTranslation = () => {
  const [fileData, setFileData] = useState([]);
  const navigate = useNavigate();

  const showWidget = () => {
    const myWidget = window.cloudinary.createUploadWidget({
      cloudName: 'rhinoconservation',
      sources: ['local', 'google_drive'],
      uploadPreset: 'bzfdzyx3',
    }, (error, result) => {
      if (!error && result && result.event === 'success') {
        setFileData([{
          id: result.info.public_id, pages: result.info.pages, name: result.info.original_filename, url: result.info.secure_url,
        }]);
        // console.log(result.info);
        // console.log((Math.ceil((result.info.duration) / 60)) * 1.5)
        // console.log((result.info.pages) * 12);
      }
    });
    myWidget.open();
  };

  localStorage.setItem('data', JSON.stringify(fileData));
  navigate('/order_translation');

  return (
    <Box sx={{
      height: '100vh', width: '100%', backgroundColor: '#F5F8FA', padding: '40px 0',
    }}
    >
      <Box sx={{ textAlign: 'center', marginBottom: '40px' }}>
        <Button variant="outlined" onClick={() => navigate('/')}>
          <ArrowBackIosOutlinedIcon />
          {' '}
          Back To Website
        </Button>
      </Box>
      <Box sx={{ textAlign: 'center', marginBottom: '40px' }}>
        <Typography sx={{
          fontWeight: '500', fontSize: { xs: '25px', sm: '30px' }, color: '#717A82', lineHeight: { xs: '30px', sm: '50px' },
        }}
        >
          Ready To Start A Project?
        </Typography>
        <Typography sx={{
          fontWeight: '300', fontSize: { xs: '15px', sm: '18px' }, color: '#717A82', lineHeight: { xs: '30px', sm: '50px' },
        }}
        >
          Upload Your Files - Calculate The Price - Pay
        </Typography>
      </Box>
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <Box sx={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', border: '4px dotted #1A76D2', padding: { xs: '50px', sm: '100px' },
        }}
        >
          <Button onClick={showWidget} variant="contained">
            <UploadOutlinedIcon />
            {' '}
            Add Files
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default UploadTranslation;
